import { defineComponent as _defineComponent } from 'vue'
import {ref, computed, onMounted, watch} from 'vue';
import { useRoute, useRouter } from "vue-router";
import { useBuilderPortalStore } from "@/store/builder-portal";
import { useBuilderStore } from "@/store/builder";
import type { checklistPrimaryNode, subChecklistNode } from '../checklist-types';
import { subChecklistItems } from "@/components/builder-portal-nav-options/nav-options";
import { toggleCollapse, collapsed } from "@/components/Navbar/navState";
// import router from '@/router';

type showStatusType = 'overdue' | 'delayed' | 'complete' | 'default'


export default /*#__PURE__*/_defineComponent({
  __name: 'builder-checklist',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const builderStore = useBuilderPortalStore();
const builder  = useBuilderStore();
const checklist = computed<checklistPrimaryNode[]>(()=> builderStore.checklistContent);
const pathToChecklistStatus = computed(() => {
	const pathToStatus: Record<string, showStatusType> = {};
	checklist.value.forEach((checklistNode) => {
		if(checklistNode.pathName) pathToStatus[checklistNode.pathName] = builderStore.getChecklistPathStatus(checklistNode.pathName) as showStatusType;
		if(checklistNode.subList){
			checklistNode.subList.forEach((checklistSubNode) => {
				if(checklistSubNode?.pathName) pathToStatus[checklistSubNode.pathName] = builderStore.getChecklistPathStatus(checklistSubNode.pathName) as showStatusType;
			});
		}
	});
	return pathToStatus;
});
const openDropdown = ref<string | null>("checklistStatus");

const handleDropdown = (selectedDropdown: string | undefined) => {
	if(!selectedDropdown) return;
	if(openDropdown.value === selectedDropdown){openDropdown.value = null;}
	else{openDropdown.value = selectedDropdown;}};
const selectedRoute = ref("none");

//const custodyAgreementCompleted = computed(()=>{
//	if(builder.currentBuilderRecord?.hasCustodyAgreement !== undefined){
//		return true;
//	}
//	return false;
//});

async function selectRoute(path:string | undefined){
	if(path){
		if(!collapsed.value){
			toggleCollapse();
		}
		await router.push(`/builder/${path}`);
	}
};

onMounted(() => {
	updateNavbar();
});

watch(() => route.fullPath, () => updateNavbar());

function checkSubPath(path:string | undefined){
	if(path){
		if(subChecklistItems.includes(path)){
			return true;
		}else{
			return false;
		}
	}
}

function updateNavbar(){
	if(route.meta?.section === "checklist"){
		openDropdown.value = 'checklistStatus';
	}

	if(route.path.split('/')?.[1] === 'builder' && route.path.split('/')?.[2]){
		selectedRoute.value = route.path.split('/')?.[2];
	}
}


const __returned__ = { route, router, builderStore, builder, checklist, pathToChecklistStatus, openDropdown, handleDropdown, selectedRoute, selectRoute, checkSubPath, updateNavbar, ref, computed, onMounted, watch, get useRoute() { return useRoute }, get useRouter() { return useRouter }, get useBuilderPortalStore() { return useBuilderPortalStore }, get useBuilderStore() { return useBuilderStore }, get subChecklistItems() { return subChecklistItems }, get toggleCollapse() { return toggleCollapse }, get collapsed() { return collapsed } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})